"use client";

import { IComunicado } from "@/services/types";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/atoms/accordion";
import RenderHtmlContentDescriptions from "../common/RenderHtmlContentDescritpions";
import Image from "next/image";
import { HighLightTitleHeading } from "../common/HighLightTitleCermiHeading";


interface ComunicadosConcursoSectionProps {
    comunicado: IComunicado;
}

const ComunicadosConcursoSection: React.FC<ComunicadosConcursoSectionProps> = ({ comunicado }) => {



    return (
        <section className="relative w-full mx-auto  px-12 sm:px-6 lg:px-12 bg-[#C3C1C033]">

            <div className="container mx-auto px-4 md:px-8 lg:px-16 pt-6 sm:pt-8 md:pt-12 lg:pt-26">
                <HighLightTitleHeading title={comunicado.title} />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12 sm:mb-16 lg:mb-20">
                    {/** comunicado image section */}
                    <div className="flex flex-col">
                        {/* Main image container */}
                        <div className="relative w-full h-full md:h-56 lg:h-full">
                            {/* Background image */}
                            {comunicado.image && <Image
                                className="object-cover"
                                width={711}
                                height={629}
                                src={comunicado?.image?.url || ""}
                                alt={comunicado?.image?.alternativeText || ""}
                                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                            />}
                        </div>
                    </div>

                    {/** comunicado list session*/}
                    <div className="lg:flex-1">
                        <Accordion type="single" collapsible>
                            {comunicado.lista_comunicados.map((comunicado_item, index) => (
                                <AccordionItem
                                    value={`pki-${index}`}
                                    key={`pki-${index}`}
                                    className="border-0 mb-2"
                                >
                                    <AccordionTrigger
                                        className="bg-white rounded-sm cursor-pointer shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)] font-poppins text-xl text-[#334155]"
                                        hasResponse>{comunicado_item.title}
                                    </AccordionTrigger>
                                    <AccordionContent className="py-4 px-4 bg-white ">
                                        <RenderHtmlContentDescriptions htmlContent={comunicado_item.description} className=" mb-6" />
                                    </AccordionContent>
                                </AccordionItem>
                            ))
                            }
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>);
};

export default ComunicadosConcursoSection;